import { createSlice } from '@reduxjs/toolkit';
import absWebService from 'app/services/absWebService';
import i18next from 'i18next';
import { showMessage } from 'app/store/abs/messageSlice';
import { setUser } from 'app/store/userSlice';

//special!!
export const updateUserSettings = (data, newuser) => async dispatch => {

	dispatch(setLoading(true));
	const response = await absWebService
		.communicationHandler("abs_update_user_settings", data)
		.catch(error => {
			if (error == null) {
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}
			//give back error for processing below
			return error;
		});

	//await catch error or server response
	const respdata = await response;
	if (absWebService.isResponseArrSuccess(respdata)) {
		//alert(JSON.stringify(respdata));
		//dispatch(showMessage({ message: "success fetching data", variant: 'success' }));

		var returndataarr = absWebService.getDataFromResponseArr(respdata);

		dispatch(setUser(newuser));


		await dispatch(getUserSettings(null));

		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		dispatch(setLoading(false));
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

export const getUserSettings = (data) => async dispatch => {

	dispatch(setLoading(true));
	const response = await absWebService
		.communicationHandler("abs_get_user_settings", data)
		.catch(error => {
			if (error == null) error = i18next.t("abswebservice:UNKNOWNERROR");
			return error;
		});

	const respdata = response;
	if (absWebService.isResponseArrSuccess(respdata)) {
		var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
		dispatch(successFetchUserSettings(returndataarr));
		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		dispatch(setLoading(false));
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

const initialState = {
	loading: false,
	abs: {},
	tl: {},
	eo: {},
	oauthConnections: [],
	oauthLoading: false,
	notifPreferences: [],
};

const userSettingsSlice = createSlice({
	name: 'userSettings/personal',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		successFetchUserSettings: (state, action) => {
			state.loading = false;
			state.abs = action.payload.abs;
			state.tl = action.payload.tl;
			state.eo = action.payload.eo;
		},
		setActivityTemplates: (state, action) => {
			state.tl.activityTemplates = action.payload;
		},
		setOauthConnections: (state, action) => {
			state.oauthConnections = action.payload;
		},
		setOauthLoading: (state, action) => {
			state.oauthLoading = action.payload;
		},
		setNotifPreferences: (state, action) => {
			state.notifPreferences = action.payload;
		},
	},
	extraReducers: {}
});

export const { setLoading, successFetchUserSettings, setActivityTemplates, setOauthConnections, setOauthLoading, setNotifPreferences } = userSettingsSlice.actions;

export const getActivityTemplates = () => async (dispatch, getState) => {
	const userId = getState().userSettings?.personal?.tl?.User_ID;
	const data = userId ? { user_id: userId } : null;
	const response = await absWebService.communicationHandler("tl_get_activity_templates", data).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		const data = absWebService.getDataFromResponseArr(response);
		dispatch(setActivityTemplates(JSON.parse(data) || []));
		return data;
	}
	return "error";
};

export const saveActivityTemplate = (data) => async () => {
	const response = await absWebService.communicationHandler("tl_save_activity_template", data).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		return absWebService.getDataFromResponseArr(response);
	}
	return "error";
};

export const deleteActivityTemplate = (templateId) => async () => {
	const response = await absWebService.communicationHandler("tl_delete_activity_template", { Template_ID: templateId }).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		return absWebService.getDataFromResponseArr(response);
	}
	return "error";
};

export const getOAuthStatus = () => async dispatch => {
	dispatch(setOauthLoading(true));
	const response = await absWebService.communicationHandler("abs_oauth_get_status", null).catch(() => null);
	dispatch(setOauthLoading(false));
	if (response && absWebService.isResponseArrSuccess(response)) {
		const data = JSON.parse(absWebService.getDataFromResponseArr(response));
		dispatch(setOauthConnections(data.connections || []));
		return data.connections;
	}
	return "error";
};

export const getOAuthUrl = (provider) => async dispatch => {
	const response = await absWebService.communicationHandler("abs_oauth_get_auth_url", { provider }).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		const data = JSON.parse(absWebService.getDataFromResponseArr(response));
		return data.auth_url;
	}
	return null;
};

export const disconnectOAuth = (connectionId) => async dispatch => {
	dispatch(setOauthLoading(true));
	const response = await absWebService.communicationHandler("abs_oauth_disconnect", { connection_id: connectionId }).catch(() => null);
	dispatch(setOauthLoading(false));
	if (response && absWebService.isResponseArrSuccess(response)) {
		await dispatch(getOAuthStatus());
		return true;
	}
	const errormessage = absWebService.getDisplayTextFromResponseArr(response);
	dispatch(showMessage({ message: errormessage, variant: 'error' }));
	return false;
};

export const getNotifPreferences = (userid = null) => async dispatch => {
	const data = userid !== null ? { userid } : null;
	const response = await absWebService.communicationHandler("abs_get_notification_preferences", data).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		const parsed = JSON.parse(absWebService.getDataFromResponseArr(response));
		const prefs = parsed?.preferences ?? parsed ?? [];
		dispatch(setNotifPreferences(Array.isArray(prefs) ? prefs : []));
		return parsed;
	}
	return "error";
};

export const saveNotifPreferences = (preferences, userid = null) => async dispatch => {
	const data = userid !== null ? { userid, preferences } : { preferences };
	const response = await absWebService.communicationHandler("abs_save_notification_preferences", data).catch(() => null);
	if (response && absWebService.isResponseArrSuccess(response)) {
		return true;
	}
	const errormessage = absWebService.getDisplayTextFromResponseArr(response);
	dispatch(showMessage({ message: errormessage, variant: 'error' }));
	return false;
};

export default userSettingsSlice.reducer;
